/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as GetInTouchRouteImport } from './routes/get-in-touch'
import { Route as WhatsNearbyVenueIdRouteImport } from './routes/whats-nearby.$venueId'
import { Route as VenuereviewsVenueIdRouteImport } from './routes/venuereviews.$venueId'
import { Route as VenuephotosVenueSlugRouteImport } from './routes/venuephotos.$venueSlug'
import { Route as VenuedetailsVenueIdRouteImport } from './routes/venuedetails.$venueId'
import { Route as ShareTokenTokenRouteImport } from './routes/share-token.$token'
import { Route as LoginEmailRouteImport } from './routes/login.$email'
import { Route as ContentSlugRouteImport } from './routes/content.$slug'
import { Route as AccessibilityGuideVenueIdRouteImport } from './routes/accessibility-guide.$venueId'
import { Route as ComplexvenuetabsVenueSlugTabIdRouteImport } from './routes/complexvenuetabs.$venueSlug.$tabId'
import { Route as AuthMicrosoftCallbackRouteImport } from './routes/auth.microsoft.callback'
import { Route as AccessibilityGuideSpaceVenueIdSpaceIdRouteImport } from './routes/accessibility-guide-space.$venueId.$spaceId'
import { Route as VerifyuserCodeUserEmailRouteImport } from './routes/verifyuser.$code.user.$email'
import { Route as SavedplacedetailsSavedPlaceIdUserUserIdRouteImport } from './routes/savedplacedetails.$savedPlaceId.user.$userId'
import { Route as ResendverifyemailUserEmailCodeRouteImport } from './routes/resendverifyemail.user.$email.$code'
import { Route as PasswordresetCodeUserEmailRouteImport } from './routes/passwordreset.$code.user.$email'

const YourTeamsLazyRouteImport = createFileRoute('/your-teams')()
const YourProfileLazyRouteImport = createFileRoute('/your-profile')()
const YourBadgesLazyRouteImport = createFileRoute('/your-badges')()
const YourActivityLazyRouteImport = createFileRoute('/your-activity')()
const YourAccessibilityProfileLazyRouteImport = createFileRoute(
  '/your-accessibility-profile',
)()
const SettingsLazyRouteImport = createFileRoute('/settings')()
const SearchLazyRouteImport = createFileRoute('/search')()
const NotificationsLazyRouteImport = createFileRoute('/notifications')()
const MysavedplacesLazyRouteImport = createFileRoute('/mysavedplaces')()
const IndexLazyRouteImport = createFileRoute('/')()

const YourTeamsLazyRoute = YourTeamsLazyRouteImport.update({
  id: '/your-teams',
  path: '/your-teams',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/your-teams.lazy').then((d) => d.Route))
const YourProfileLazyRoute = YourProfileLazyRouteImport.update({
  id: '/your-profile',
  path: '/your-profile',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/your-profile.lazy').then((d) => d.Route))
const YourBadgesLazyRoute = YourBadgesLazyRouteImport.update({
  id: '/your-badges',
  path: '/your-badges',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/your-badges.lazy').then((d) => d.Route))
const YourActivityLazyRoute = YourActivityLazyRouteImport.update({
  id: '/your-activity',
  path: '/your-activity',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/your-activity.lazy').then((d) => d.Route))
const YourAccessibilityProfileLazyRoute =
  YourAccessibilityProfileLazyRouteImport.update({
    id: '/your-accessibility-profile',
    path: '/your-accessibility-profile',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/your-accessibility-profile.lazy').then((d) => d.Route),
  )
const SettingsLazyRoute = SettingsLazyRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/settings.lazy').then((d) => d.Route))
const SearchLazyRoute = SearchLazyRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/search.lazy').then((d) => d.Route))
const NotificationsLazyRoute = NotificationsLazyRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/notifications.lazy').then((d) => d.Route))
const MysavedplacesLazyRoute = MysavedplacesLazyRouteImport.update({
  id: '/mysavedplaces',
  path: '/mysavedplaces',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/mysavedplaces.lazy').then((d) => d.Route))
const GetInTouchRoute = GetInTouchRouteImport.update({
  id: '/get-in-touch',
  path: '/get-in-touch',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const WhatsNearbyVenueIdRoute = WhatsNearbyVenueIdRouteImport.update({
  id: '/whats-nearby/$venueId',
  path: '/whats-nearby/$venueId',
  getParentRoute: () => rootRouteImport,
} as any)
const VenuereviewsVenueIdRoute = VenuereviewsVenueIdRouteImport.update({
  id: '/venuereviews/$venueId',
  path: '/venuereviews/$venueId',
  getParentRoute: () => rootRouteImport,
} as any)
const VenuephotosVenueSlugRoute = VenuephotosVenueSlugRouteImport.update({
  id: '/venuephotos/$venueSlug',
  path: '/venuephotos/$venueSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const VenuedetailsVenueIdRoute = VenuedetailsVenueIdRouteImport.update({
  id: '/venuedetails/$venueId',
  path: '/venuedetails/$venueId',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareTokenTokenRoute = ShareTokenTokenRouteImport.update({
  id: '/share-token/$token',
  path: '/share-token/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginEmailRoute = LoginEmailRouteImport.update({
  id: '/login/$email',
  path: '/login/$email',
  getParentRoute: () => rootRouteImport,
} as any)
const ContentSlugRoute = ContentSlugRouteImport.update({
  id: '/content/$slug',
  path: '/content/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessibilityGuideVenueIdRoute =
  AccessibilityGuideVenueIdRouteImport.update({
    id: '/accessibility-guide/$venueId',
    path: '/accessibility-guide/$venueId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ComplexvenuetabsVenueSlugTabIdRoute =
  ComplexvenuetabsVenueSlugTabIdRouteImport.update({
    id: '/complexvenuetabs/$venueSlug/$tabId',
    path: '/complexvenuetabs/$venueSlug/$tabId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthMicrosoftCallbackRoute = AuthMicrosoftCallbackRouteImport.update({
  id: '/auth/microsoft/callback',
  path: '/auth/microsoft/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessibilityGuideSpaceVenueIdSpaceIdRoute =
  AccessibilityGuideSpaceVenueIdSpaceIdRouteImport.update({
    id: '/accessibility-guide-space/$venueId/$spaceId',
    path: '/accessibility-guide-space/$venueId/$spaceId',
    getParentRoute: () => rootRouteImport,
  } as any)
const VerifyuserCodeUserEmailRoute = VerifyuserCodeUserEmailRouteImport.update({
  id: '/verifyuser/$code/user/$email',
  path: '/verifyuser/$code/user/$email',
  getParentRoute: () => rootRouteImport,
} as any)
const SavedplacedetailsSavedPlaceIdUserUserIdRoute =
  SavedplacedetailsSavedPlaceIdUserUserIdRouteImport.update({
    id: '/savedplacedetails/$savedPlaceId/user/$userId',
    path: '/savedplacedetails/$savedPlaceId/user/$userId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ResendverifyemailUserEmailCodeRoute =
  ResendverifyemailUserEmailCodeRouteImport.update({
    id: '/resendverifyemail/user/$email/$code',
    path: '/resendverifyemail/user/$email/$code',
    getParentRoute: () => rootRouteImport,
  } as any)
const PasswordresetCodeUserEmailRoute =
  PasswordresetCodeUserEmailRouteImport.update({
    id: '/passwordreset/$code/user/$email',
    path: '/passwordreset/$code/user/$email',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/get-in-touch': typeof GetInTouchRoute
  '/mysavedplaces': typeof MysavedplacesLazyRoute
  '/notifications': typeof NotificationsLazyRoute
  '/search': typeof SearchLazyRoute
  '/settings': typeof SettingsLazyRoute
  '/your-accessibility-profile': typeof YourAccessibilityProfileLazyRoute
  '/your-activity': typeof YourActivityLazyRoute
  '/your-badges': typeof YourBadgesLazyRoute
  '/your-profile': typeof YourProfileLazyRoute
  '/your-teams': typeof YourTeamsLazyRoute
  '/accessibility-guide/$venueId': typeof AccessibilityGuideVenueIdRoute
  '/content/$slug': typeof ContentSlugRoute
  '/login/$email': typeof LoginEmailRoute
  '/share-token/$token': typeof ShareTokenTokenRoute
  '/venuedetails/$venueId': typeof VenuedetailsVenueIdRoute
  '/venuephotos/$venueSlug': typeof VenuephotosVenueSlugRoute
  '/venuereviews/$venueId': typeof VenuereviewsVenueIdRoute
  '/whats-nearby/$venueId': typeof WhatsNearbyVenueIdRoute
  '/accessibility-guide-space/$venueId/$spaceId': typeof AccessibilityGuideSpaceVenueIdSpaceIdRoute
  '/auth/microsoft/callback': typeof AuthMicrosoftCallbackRoute
  '/complexvenuetabs/$venueSlug/$tabId': typeof ComplexvenuetabsVenueSlugTabIdRoute
  '/passwordreset/$code/user/$email': typeof PasswordresetCodeUserEmailRoute
  '/resendverifyemail/user/$email/$code': typeof ResendverifyemailUserEmailCodeRoute
  '/savedplacedetails/$savedPlaceId/user/$userId': typeof SavedplacedetailsSavedPlaceIdUserUserIdRoute
  '/verifyuser/$code/user/$email': typeof VerifyuserCodeUserEmailRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/get-in-touch': typeof GetInTouchRoute
  '/mysavedplaces': typeof MysavedplacesLazyRoute
  '/notifications': typeof NotificationsLazyRoute
  '/search': typeof SearchLazyRoute
  '/settings': typeof SettingsLazyRoute
  '/your-accessibility-profile': typeof YourAccessibilityProfileLazyRoute
  '/your-activity': typeof YourActivityLazyRoute
  '/your-badges': typeof YourBadgesLazyRoute
  '/your-profile': typeof YourProfileLazyRoute
  '/your-teams': typeof YourTeamsLazyRoute
  '/accessibility-guide/$venueId': typeof AccessibilityGuideVenueIdRoute
  '/content/$slug': typeof ContentSlugRoute
  '/login/$email': typeof LoginEmailRoute
  '/share-token/$token': typeof ShareTokenTokenRoute
  '/venuedetails/$venueId': typeof VenuedetailsVenueIdRoute
  '/venuephotos/$venueSlug': typeof VenuephotosVenueSlugRoute
  '/venuereviews/$venueId': typeof VenuereviewsVenueIdRoute
  '/whats-nearby/$venueId': typeof WhatsNearbyVenueIdRoute
  '/accessibility-guide-space/$venueId/$spaceId': typeof AccessibilityGuideSpaceVenueIdSpaceIdRoute
  '/auth/microsoft/callback': typeof AuthMicrosoftCallbackRoute
  '/complexvenuetabs/$venueSlug/$tabId': typeof ComplexvenuetabsVenueSlugTabIdRoute
  '/passwordreset/$code/user/$email': typeof PasswordresetCodeUserEmailRoute
  '/resendverifyemail/user/$email/$code': typeof ResendverifyemailUserEmailCodeRoute
  '/savedplacedetails/$savedPlaceId/user/$userId': typeof SavedplacedetailsSavedPlaceIdUserUserIdRoute
  '/verifyuser/$code/user/$email': typeof VerifyuserCodeUserEmailRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/get-in-touch': typeof GetInTouchRoute
  '/mysavedplaces': typeof MysavedplacesLazyRoute
  '/notifications': typeof NotificationsLazyRoute
  '/search': typeof SearchLazyRoute
  '/settings': typeof SettingsLazyRoute
  '/your-accessibility-profile': typeof YourAccessibilityProfileLazyRoute
  '/your-activity': typeof YourActivityLazyRoute
  '/your-badges': typeof YourBadgesLazyRoute
  '/your-profile': typeof YourProfileLazyRoute
  '/your-teams': typeof YourTeamsLazyRoute
  '/accessibility-guide/$venueId': typeof AccessibilityGuideVenueIdRoute
  '/content/$slug': typeof ContentSlugRoute
  '/login/$email': typeof LoginEmailRoute
  '/share-token/$token': typeof ShareTokenTokenRoute
  '/venuedetails/$venueId': typeof VenuedetailsVenueIdRoute
  '/venuephotos/$venueSlug': typeof VenuephotosVenueSlugRoute
  '/venuereviews/$venueId': typeof VenuereviewsVenueIdRoute
  '/whats-nearby/$venueId': typeof WhatsNearbyVenueIdRoute
  '/accessibility-guide-space/$venueId/$spaceId': typeof AccessibilityGuideSpaceVenueIdSpaceIdRoute
  '/auth/microsoft/callback': typeof AuthMicrosoftCallbackRoute
  '/complexvenuetabs/$venueSlug/$tabId': typeof ComplexvenuetabsVenueSlugTabIdRoute
  '/passwordreset/$code/user/$email': typeof PasswordresetCodeUserEmailRoute
  '/resendverifyemail/user/$email/$code': typeof ResendverifyemailUserEmailCodeRoute
  '/savedplacedetails/$savedPlaceId/user/$userId': typeof SavedplacedetailsSavedPlaceIdUserUserIdRoute
  '/verifyuser/$code/user/$email': typeof VerifyuserCodeUserEmailRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/get-in-touch'
    | '/mysavedplaces'
    | '/notifications'
    | '/search'
    | '/settings'
    | '/your-accessibility-profile'
    | '/your-activity'
    | '/your-badges'
    | '/your-profile'
    | '/your-teams'
    | '/accessibility-guide/$venueId'
    | '/content/$slug'
    | '/login/$email'
    | '/share-token/$token'
    | '/venuedetails/$venueId'
    | '/venuephotos/$venueSlug'
    | '/venuereviews/$venueId'
    | '/whats-nearby/$venueId'
    | '/accessibility-guide-space/$venueId/$spaceId'
    | '/auth/microsoft/callback'
    | '/complexvenuetabs/$venueSlug/$tabId'
    | '/passwordreset/$code/user/$email'
    | '/resendverifyemail/user/$email/$code'
    | '/savedplacedetails/$savedPlaceId/user/$userId'
    | '/verifyuser/$code/user/$email'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/get-in-touch'
    | '/mysavedplaces'
    | '/notifications'
    | '/search'
    | '/settings'
    | '/your-accessibility-profile'
    | '/your-activity'
    | '/your-badges'
    | '/your-profile'
    | '/your-teams'
    | '/accessibility-guide/$venueId'
    | '/content/$slug'
    | '/login/$email'
    | '/share-token/$token'
    | '/venuedetails/$venueId'
    | '/venuephotos/$venueSlug'
    | '/venuereviews/$venueId'
    | '/whats-nearby/$venueId'
    | '/accessibility-guide-space/$venueId/$spaceId'
    | '/auth/microsoft/callback'
    | '/complexvenuetabs/$venueSlug/$tabId'
    | '/passwordreset/$code/user/$email'
    | '/resendverifyemail/user/$email/$code'
    | '/savedplacedetails/$savedPlaceId/user/$userId'
    | '/verifyuser/$code/user/$email'
  id:
    | '__root__'
    | '/'
    | '/get-in-touch'
    | '/mysavedplaces'
    | '/notifications'
    | '/search'
    | '/settings'
    | '/your-accessibility-profile'
    | '/your-activity'
    | '/your-badges'
    | '/your-profile'
    | '/your-teams'
    | '/accessibility-guide/$venueId'
    | '/content/$slug'
    | '/login/$email'
    | '/share-token/$token'
    | '/venuedetails/$venueId'
    | '/venuephotos/$venueSlug'
    | '/venuereviews/$venueId'
    | '/whats-nearby/$venueId'
    | '/accessibility-guide-space/$venueId/$spaceId'
    | '/auth/microsoft/callback'
    | '/complexvenuetabs/$venueSlug/$tabId'
    | '/passwordreset/$code/user/$email'
    | '/resendverifyemail/user/$email/$code'
    | '/savedplacedetails/$savedPlaceId/user/$userId'
    | '/verifyuser/$code/user/$email'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  GetInTouchRoute: typeof GetInTouchRoute
  MysavedplacesLazyRoute: typeof MysavedplacesLazyRoute
  NotificationsLazyRoute: typeof NotificationsLazyRoute
  SearchLazyRoute: typeof SearchLazyRoute
  SettingsLazyRoute: typeof SettingsLazyRoute
  YourAccessibilityProfileLazyRoute: typeof YourAccessibilityProfileLazyRoute
  YourActivityLazyRoute: typeof YourActivityLazyRoute
  YourBadgesLazyRoute: typeof YourBadgesLazyRoute
  YourProfileLazyRoute: typeof YourProfileLazyRoute
  YourTeamsLazyRoute: typeof YourTeamsLazyRoute
  AccessibilityGuideVenueIdRoute: typeof AccessibilityGuideVenueIdRoute
  ContentSlugRoute: typeof ContentSlugRoute
  LoginEmailRoute: typeof LoginEmailRoute
  ShareTokenTokenRoute: typeof ShareTokenTokenRoute
  VenuedetailsVenueIdRoute: typeof VenuedetailsVenueIdRoute
  VenuephotosVenueSlugRoute: typeof VenuephotosVenueSlugRoute
  VenuereviewsVenueIdRoute: typeof VenuereviewsVenueIdRoute
  WhatsNearbyVenueIdRoute: typeof WhatsNearbyVenueIdRoute
  AccessibilityGuideSpaceVenueIdSpaceIdRoute: typeof AccessibilityGuideSpaceVenueIdSpaceIdRoute
  AuthMicrosoftCallbackRoute: typeof AuthMicrosoftCallbackRoute
  ComplexvenuetabsVenueSlugTabIdRoute: typeof ComplexvenuetabsVenueSlugTabIdRoute
  PasswordresetCodeUserEmailRoute: typeof PasswordresetCodeUserEmailRoute
  ResendverifyemailUserEmailCodeRoute: typeof ResendverifyemailUserEmailCodeRoute
  SavedplacedetailsSavedPlaceIdUserUserIdRoute: typeof SavedplacedetailsSavedPlaceIdUserUserIdRoute
  VerifyuserCodeUserEmailRoute: typeof VerifyuserCodeUserEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/your-teams': {
      id: '/your-teams'
      path: '/your-teams'
      fullPath: '/your-teams'
      preLoaderRoute: typeof YourTeamsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/your-profile': {
      id: '/your-profile'
      path: '/your-profile'
      fullPath: '/your-profile'
      preLoaderRoute: typeof YourProfileLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/your-badges': {
      id: '/your-badges'
      path: '/your-badges'
      fullPath: '/your-badges'
      preLoaderRoute: typeof YourBadgesLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/your-activity': {
      id: '/your-activity'
      path: '/your-activity'
      fullPath: '/your-activity'
      preLoaderRoute: typeof YourActivityLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/your-accessibility-profile': {
      id: '/your-accessibility-profile'
      path: '/your-accessibility-profile'
      fullPath: '/your-accessibility-profile'
      preLoaderRoute: typeof YourAccessibilityProfileLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mysavedplaces': {
      id: '/mysavedplaces'
      path: '/mysavedplaces'
      fullPath: '/mysavedplaces'
      preLoaderRoute: typeof MysavedplacesLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/get-in-touch': {
      id: '/get-in-touch'
      path: '/get-in-touch'
      fullPath: '/get-in-touch'
      preLoaderRoute: typeof GetInTouchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/whats-nearby/$venueId': {
      id: '/whats-nearby/$venueId'
      path: '/whats-nearby/$venueId'
      fullPath: '/whats-nearby/$venueId'
      preLoaderRoute: typeof WhatsNearbyVenueIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/venuereviews/$venueId': {
      id: '/venuereviews/$venueId'
      path: '/venuereviews/$venueId'
      fullPath: '/venuereviews/$venueId'
      preLoaderRoute: typeof VenuereviewsVenueIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/venuephotos/$venueSlug': {
      id: '/venuephotos/$venueSlug'
      path: '/venuephotos/$venueSlug'
      fullPath: '/venuephotos/$venueSlug'
      preLoaderRoute: typeof VenuephotosVenueSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/venuedetails/$venueId': {
      id: '/venuedetails/$venueId'
      path: '/venuedetails/$venueId'
      fullPath: '/venuedetails/$venueId'
      preLoaderRoute: typeof VenuedetailsVenueIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share-token/$token': {
      id: '/share-token/$token'
      path: '/share-token/$token'
      fullPath: '/share-token/$token'
      preLoaderRoute: typeof ShareTokenTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/$email': {
      id: '/login/$email'
      path: '/login/$email'
      fullPath: '/login/$email'
      preLoaderRoute: typeof LoginEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/content/$slug': {
      id: '/content/$slug'
      path: '/content/$slug'
      fullPath: '/content/$slug'
      preLoaderRoute: typeof ContentSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accessibility-guide/$venueId': {
      id: '/accessibility-guide/$venueId'
      path: '/accessibility-guide/$venueId'
      fullPath: '/accessibility-guide/$venueId'
      preLoaderRoute: typeof AccessibilityGuideVenueIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complexvenuetabs/$venueSlug/$tabId': {
      id: '/complexvenuetabs/$venueSlug/$tabId'
      path: '/complexvenuetabs/$venueSlug/$tabId'
      fullPath: '/complexvenuetabs/$venueSlug/$tabId'
      preLoaderRoute: typeof ComplexvenuetabsVenueSlugTabIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/microsoft/callback': {
      id: '/auth/microsoft/callback'
      path: '/auth/microsoft/callback'
      fullPath: '/auth/microsoft/callback'
      preLoaderRoute: typeof AuthMicrosoftCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accessibility-guide-space/$venueId/$spaceId': {
      id: '/accessibility-guide-space/$venueId/$spaceId'
      path: '/accessibility-guide-space/$venueId/$spaceId'
      fullPath: '/accessibility-guide-space/$venueId/$spaceId'
      preLoaderRoute: typeof AccessibilityGuideSpaceVenueIdSpaceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verifyuser/$code/user/$email': {
      id: '/verifyuser/$code/user/$email'
      path: '/verifyuser/$code/user/$email'
      fullPath: '/verifyuser/$code/user/$email'
      preLoaderRoute: typeof VerifyuserCodeUserEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/savedplacedetails/$savedPlaceId/user/$userId': {
      id: '/savedplacedetails/$savedPlaceId/user/$userId'
      path: '/savedplacedetails/$savedPlaceId/user/$userId'
      fullPath: '/savedplacedetails/$savedPlaceId/user/$userId'
      preLoaderRoute: typeof SavedplacedetailsSavedPlaceIdUserUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resendverifyemail/user/$email/$code': {
      id: '/resendverifyemail/user/$email/$code'
      path: '/resendverifyemail/user/$email/$code'
      fullPath: '/resendverifyemail/user/$email/$code'
      preLoaderRoute: typeof ResendverifyemailUserEmailCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/passwordreset/$code/user/$email': {
      id: '/passwordreset/$code/user/$email'
      path: '/passwordreset/$code/user/$email'
      fullPath: '/passwordreset/$code/user/$email'
      preLoaderRoute: typeof PasswordresetCodeUserEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  GetInTouchRoute: GetInTouchRoute,
  MysavedplacesLazyRoute: MysavedplacesLazyRoute,
  NotificationsLazyRoute: NotificationsLazyRoute,
  SearchLazyRoute: SearchLazyRoute,
  SettingsLazyRoute: SettingsLazyRoute,
  YourAccessibilityProfileLazyRoute: YourAccessibilityProfileLazyRoute,
  YourActivityLazyRoute: YourActivityLazyRoute,
  YourBadgesLazyRoute: YourBadgesLazyRoute,
  YourProfileLazyRoute: YourProfileLazyRoute,
  YourTeamsLazyRoute: YourTeamsLazyRoute,
  AccessibilityGuideVenueIdRoute: AccessibilityGuideVenueIdRoute,
  ContentSlugRoute: ContentSlugRoute,
  LoginEmailRoute: LoginEmailRoute,
  ShareTokenTokenRoute: ShareTokenTokenRoute,
  VenuedetailsVenueIdRoute: VenuedetailsVenueIdRoute,
  VenuephotosVenueSlugRoute: VenuephotosVenueSlugRoute,
  VenuereviewsVenueIdRoute: VenuereviewsVenueIdRoute,
  WhatsNearbyVenueIdRoute: WhatsNearbyVenueIdRoute,
  AccessibilityGuideSpaceVenueIdSpaceIdRoute:
    AccessibilityGuideSpaceVenueIdSpaceIdRoute,
  AuthMicrosoftCallbackRoute: AuthMicrosoftCallbackRoute,
  ComplexvenuetabsVenueSlugTabIdRoute: ComplexvenuetabsVenueSlugTabIdRoute,
  PasswordresetCodeUserEmailRoute: PasswordresetCodeUserEmailRoute,
  ResendverifyemailUserEmailCodeRoute: ResendverifyemailUserEmailCodeRoute,
  SavedplacedetailsSavedPlaceIdUserUserIdRoute:
    SavedplacedetailsSavedPlaceIdUserUserIdRoute,
  VerifyuserCodeUserEmailRoute: VerifyuserCodeUserEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
